export default function Title({ as: Tag = 'h2', children, style, ...rest }) {
  return (
    <Tag
      style={{
        fontFamily: 'var(--font-body)',
        fontWeight: 600,
        fontSize: 22,
        lineHeight: '28px',
        color: 'var(--text-primary)',
        textTransform: 'none',
        letterSpacing: 0,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
